<div *ngIf="(currentUser$|async) as currentUser" appFlex appFlexLayout="column" class="h-100-p w-100-p p-8">

  <h2>Générateur de liens pour les publications/participants</h2>

  <div appFlexLayout="column" appFlexAlign="center end">
    <app-publication-selector appFlex class="p-4" (selectedPublicationChanged)="publicationChanged($event)"></app-publication-selector>
    <mat-checkbox [formControl]="modeTestSelected" class="block">
      <i class="mdi mdi-test-tube"></i> Mode test - (&debug=123)
    </mat-checkbox>
  </div>

  <h2>{{'Lien de connexion direct pour l\'utilisateur'}} :</h2>
  <app-url-placeholder class="p-5" [url]="getUrl(currentUser.jwtToken, selectedPublication, true)"></app-url-placeholder>


  <div *appIfDebugMode="true" class="p-8" style="overflow: auto;">
    <pre>{{getUrl(currentUser.jwtToken, selectedPublication, true)}}</pre>
  </div>

  <ng-container *appIfUserHas="['GOD_MODE']">
    <hr>
    <h2>Legacy (old app)</h2>
    <app-url-placeholder class="p-5" [url]="getUrl(currentUser.jwtToken, selectedPublication)"></app-url-placeholder>
    <div *appIfDebugMode="true" class="p-8" style="overflow: auto;">
      <pre>{{getUrl(currentUser.jwtToken, selectedPublication)}}</pre>
    </div>
  </ng-container>

</div>
